import React from 'react'
import Fade from 'react-reveal/Fade'
import ContentForm from '../../UI/ContentForm/ContentForm'
import Button from '../../UI/Button/Button'
import Spinner from '../../UI/Spinner/Spinner'
import FetchData from '../../../shared/fetchData'


const ViewKioskType = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [lockerTypes, setLockerTypes] = React.useState([])
    const [lockerTypeList, setLockerTypeList] = React.useState('')

    React.useEffect(() => {
        var raw = JSON.stringify({
            "lockerType": {
            },
            "pl": '10000',
            "pn": '1',
            "version": "mtpx001"
        })
        var url = 'management/api/v1/lockertypes/getLockerTypes'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setLockerTypes(result.lockerTypes)
                }
            })
            .catch(error => setLoading(false))
        var raw = JSON.stringify({
            "kioskLockerType": {
                "kioskType": {
                    "id": props.kioskType.id
                }
            },
            "pl": '10000',
            "pn": '1',
            "version": "mtpx001"
        })
        var url = 'management/api/v1/kiosklockertypes/getKioskLockerTypes'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    const lckTp = []
                    result.kioskLockerTypes.map(l => {
                        lckTp.push({
                            "id": l.lockerType.id,
                            "serial": l.serial
                        })
                    })
                    setLockerTypeList(lckTp)
                }
            })
            .catch(error => setLoading(false))
    }, [])
    let lckrTypesShow = lockerTypeList != null && lockerTypeList.length != 0 ? lockerTypeList.map(l => {
        const lt = lockerTypes.filter(lt => lt.id == l.id)
        if (lt != null && lt.length != 0) {
            return (
                <div className='col-4 full-small'>
                    <div className='show-lckr-tp'>
                        <div className='col-4'>
                            سریال:{l.serial}
                        </div>
                        <div className='col-8'>
                            {lt[0].description}
                        </div>
                    </div>
                </div>
            )
        }
    })
        : ''

    const spinner = loading ? <Spinner /> : ''
    return (
        <Fade duration={200} left cascade>
            <div>
                {spinner}
                <div className='row justify-content-center'>
                    <div className='ksk-tp-cntnr'>
                        <ContentForm headetText={props.kioskType.description}>
                            {lckrTypesShow}
                            <div className="row justify-content-center mt-3 w-100">
                                <Button className="General" clicked={props.back} >برگشت</Button>
                            </div>
                        </ContentForm>
                    </div>
                </div>
            </div>
        </Fade>
    )
}

export default ViewKioskType